export default {
	'dashboard.addAttachmentToAssignment': 'Add Attachment to Assignment',
	'dashboard.addFollowers': 'Add Followers',
	'dashboard.addNote': 'Add Note',
	'dashboard.addNoteAssignment': 'Add Note to Assignment',
	'dashboard.addNoteCount': 'Add Note to (%{count}) Assignments',
	'dashboard.assignmentSearch': '<h4>Powerful assignment search</h4><p>Use the keyword search to quickly find a specific assignment.</p>',
	'dashboard.assignmentViews': '<h4>Various assignment views</h4><p>Check out the calendar view for an alternative to the default list-view.</p><p>Or, try the map view to see a geographic visualization of where your assignments are happening in real-time!</p>',
	'dashboard.bulkAddAttachmentsTo': 'Bulk Add Attachments to (%{count}) Assignments',
	'dashboard.bulkAddLabel': 'Bulk Add Label',
	'dashboard.bulkPayment': 'Bulk Payment',
	'dashboard.bundleAction': 'Bundle Actions',
	'dashboard.cancelAssignments': 'Cancel Assignments',
	'dashboard.cannotAddLabel': 'Cannot Add This Label',
	'dashboard.copyAssignment': 'Copy Assignment',
	'dashboard.deleteAssignments': 'Delete Assignments',
	'dashboard.downloadAttachments': 'Download Attachments',
	'dashboard.dropToAddLabel': 'Drop to Add Label',
	'dashboard.editAssignment': 'Edit Assignment',
	'dashboard.editCustomFields': 'Bulk Edit Custom Fields',
	'dashboard.errorDeletingAssignments': 'There was an error deleting your assignments.',
	'dashboard.errorFetchingModal': 'There was an error fetching this modal. Please try again',
	'dashboard.errorRoutingAssignments': 'Assignments that are part of a bundle cannot be routed in bulk.',
	'dashboard.errorSavingFollower': 'An error while saving.',
	'dashboard.existingSettingSuccess': 'Existing publish settings will be retained.',
	'dashboard.followerUpdateMessage': 'Followers of this assignment have been updated.',
	'dashboard.hideFilters': 'Hide filters',
	'dashboard.hideUnused': 'Hide Unused',
	'dashboard.learnMore': 'Learn more',
	'dashboard.newCalendar': 'Create New Calendar',
	'dashboard.noCheckBoxSelected': 'No field checkboxes were selected.',
	'dashboard.noFollowerMessage': 'Currently no followers. Type a name below to start adding.',
	'dashboard.noNameError': 'You must add at least one name to save as a follower.',
	'dashboard.payTax': 'Know what you owe, and pay taxes as you go.',
	'dashboard.paymentInfoError': 'Could not get payment info for this assignment.',
	'dashboard.paymentPayingError': 'There was an error paying this assignment. Please try again.',
	'dashboard.publishAssignmentError': 'An error occurred while publishing the assignments.',
	'dashboard.removeAttachments': 'Remove Attachments',
	'dashboard.removeLabel': 'Remove Label',
	'dashboard.removeLabelWarning': '<strong>WARNING:</strong> You have selected to remove all labels from the selected assignments. Submitting this request will remove all labels',
	'dashboard.rescheduleAssignment': 'Reschedule Assignment',
	'dashboard.rescheduleCountAssignment': 'Reschedule (%{count}) Assignments',
	'dashboard.routeAssignments': 'Route Assignments',
	'dashboard.routingAssignmentsError': 'An error occurred while routing the assignments.',
	'dashboard.scheduleTimeError': 'Please specify schedule time',
	'dashboard.selectClient': 'Please select client',
	'dashboard.showFilters': 'Show more filters',
	'dashboard.showUnused': 'Show Unused',
	'dashboard.syncGoogleCalendar': 'Sync to Google Calendar',
	'dashboard.taxPaymentDue': '1st Quarter 2016 Estimated Tax Payment Due',
	'dashboard.taxReturn2015': 'Individual Tax Returns Due for Tax Year 2015',
	'dashboard.timeWindowError': 'Please specify time window',
	'dashboard.updateClientsProjects': 'Update Clients / Projects'
};


// WEBPACK FOOTER //
// ./~/@workmarket/translation/dist-es/messages/en-us/dashboard.js